import { createSlice } from "@reduxjs/toolkit";
import { PeriodicidadeModel } from "../../../models/periodicidade/periodicidadeModel";
import { listarPeriodicidade } from "../../../services/periodicidadeService";
import { resetAll } from "../../actions/actions";

export interface PeriodicidadeState {
  //buscar periodicidade
  loading: boolean;
  list: PeriodicidadeModel[];
}

const initialState: PeriodicidadeState = {
  //buscar periodicidade
  loading: false,
  list: [],
};

export const periodicidadeSlice = createSlice({
  name: "periodicidade",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar periodicidade
    builder.addCase(listarPeriodicidade.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarPeriodicidade.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(listarPeriodicidade.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {} = periodicidadeSlice.actions;

export default periodicidadeSlice.reducer;
